import * as React from "react";
import _ from "lodash";
import { saveAs } from "file-saver";
import { evaluateCondition } from "../conditions";
export const buildFormComponent = (fieldName, fields, schema, uiSchema, formData, errors, changeFunction) => {
    const fieldSchema = schema.properties[fieldName];
    const fieldUiSchema = uiSchema[fieldName];
    const fieldData = formData[fieldName];
    const fieldErrors = errors[fieldName];
    const Component = fields[fieldUiSchema["ui:field"]];
    return (React.createElement(Component, { key: fieldName, schema: fieldSchema, uiSchema: fieldUiSchema, formData: fieldData, errors: fieldErrors, onChange: changeFunction(fieldName) }));
};
export const handleErrorClick = (source, error) => {
    console.log("Error clicked:", source, error);
};
export const evaluateFormFields = (properties, uiSchema, formData) => {
    let disabled = false;
    let hidden = false;
    let newUiSchema = Object.assign({}, uiSchema);
    for (let field in properties) {
        if (uiSchema[field]["ui:field"] === "separator") {
            const sepProperties = properties[field].properties;
            const sepUiSchema = newUiSchema[field];
            newUiSchema[field] = evaluateFormFields(sepProperties, sepUiSchema, formData);
        }
        else if (uiSchema[field]["ui:field"] === "listfield") {
            const listProperties = properties[field].items.properties;
            const listUiSchema = newUiSchema[field];
            newUiSchema[field] = evaluateFormFields(listProperties, listUiSchema, formData);
        }
        if (typeof properties[field].disableCondition !== "undefined" &&
            properties[field].disableCondition !== "") {
            try {
                disabled = evaluateCondition(properties[field].disableCondition, formData);
            }
            catch (_) {
                console.warn("Could not evaluate :", properties[field].disableCondition, formData);
            }
            newUiSchema[field]["ui:disabled"] = disabled;
        }
        if (typeof uiSchema[field]["ui:hidden"] === "string") {
            try {
                hidden = evaluateCondition(uiSchema[field]["ui:hidden"], formData);
            }
            catch (_) {
                console.warn("Could not evaluate :", uiSchema[field]["ui:hidden"], formData);
            }
            newUiSchema[field] = Object.assign(Object.assign({}, newUiSchema[field]), { "ui:hidden": hidden });
        }
    }
    return newUiSchema;
};
export const setDisable = (hasTab, contextData, uiSchema, schema, formData) => {
    let newUiSchema = Object.assign({}, uiSchema);
    let disabled = false;
    let parsedFormData = Object.assign(Object.assign({}, flattenData(schema, uiSchema, formData)), contextData);
    for (let field in formData) {
        if (!isNaN(formData[field]) &&
            formData[field] !== "" &&
            typeof formData[field] !== "boolean") {
            parsedFormData[field] = parseInt(formData[field]);
        }
    }
    if (hasTab) {
        for (let tabId in schema.properties) {
            let tab = schema.properties[tabId];
            const properties = tab.properties;
            newUiSchema[tabId] = evaluateFormFields(properties, newUiSchema[tabId], parsedFormData);
            if (typeof tab.disableCondition !== "undefined" &&
                tab.disableCondition !== "") {
                try {
                    disabled = evaluateCondition(tab.disableCondition, parsedFormData);
                }
                catch (_) {
                    console.warn("Could not evaluate :", tab.disableCondition, parsedFormData);
                }
                newUiSchema[tabId]["ui:disabled"] = disabled ? true : false;
            }
        }
    }
    else {
        newUiSchema = evaluateFormFields(schema.properties, newUiSchema, parsedFormData);
    }
    return newUiSchema;
};
export const setAll2Readonly = (uiSchema) => {
    let newUiSchema = _.cloneDeep(uiSchema);
    const components = newUiSchema["ui:order"];
    for (let i in components) {
        const key = components[i];
        newUiSchema[key]["ui:readOnly"] = true;
    }
    return newUiSchema;
};
const listHeader = (fields, separator) => fields.map(escapeText).join(separator);
const listRow = (data, fields, separator) => fields
    .map((key) => data[key])
    .map(escapeText)
    .join(separator);
const escapeText = (k) => `"${k}"`;
export function saveFile(filename, content) {
    const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
    saveAs(blob, filename);
}
export const list2csv = (formData, fields, uiSchema, schema) => {
    const separator = ",";
    const headers = [];
    const keys = [];
    const parsedData = flattenDataList(schema, uiSchema, formData);
    fields.forEach((field) => {
        headers.push(field["headerName"]);
        keys.push(field["field"]);
    });
    let csvText = `${listHeader(headers, separator)}\n`;
    if (Array.isArray(parsedData)) {
        getObjRealValue(parsedData).forEach((data) => {
            csvText += `${listRow(data, keys, separator)}\n`;
        });
    }
    else if (typeof parsedData === "object") {
        sanitizeData(parsedData, formData.length).forEach((data) => {
            csvText += `${listRow(data, keys, separator)}\n`;
        });
    }
    return csvText;
};
export function sanitizeData(flatData, num) {
    let sanitizedData = [];
    for (const row in flatData) {
        let obj = {};
        for (const key in flatData[row]) {
            obj[key] = flatData[row][key];
            for (const subkey in flatData[row][key]) {
                if (subkey.startsWith("SEPAR")) {
                    for (const lastkey in flatData[row][key][subkey]) {
                        obj[lastkey] = flatData[row][key][subkey][lastkey];
                    }
                }
                obj[subkey] = flatData[row][key][subkey];
            }
        }
        sanitizedData.push(obj);
    }
    sanitizedData.splice(num, sanitizedData.length);
    return getObjRealValue(sanitizedData);
}
export function getObjRealValue(sanData) {
    sanData.forEach((row) => {
        for (const key in row) {
            if (typeof row[key] === "object" &&
                row[key]["dateTime"] !== undefined &&
                row[key]["dateTime"] !== null) {
                row[key] = row[key]["dateTime"];
            }
            if (typeof row[key] === "object" &&
                row[key]["start"] !== undefined &&
                row[key]["start"] !== null) {
                row[key] =
                    "[" +
                        row[key].start.modifier +
                        " " +
                        row[key].start.dateTime +
                        " - " +
                        row[key].end.modifier +
                        " " +
                        row[key].end.dateTime +
                        "]";
            }
        }
    });
    return sanData;
}
export function flattenData(schema, uiSchema, formData) {
    let parsedFormData = Object.assign({}, formData);
    if (parsedFormData === null ||
        typeof parsedFormData === "undefined" ||
        Object.keys(parsedFormData).length === 0) {
        return parsedFormData;
    }
    const firstComp = uiSchema["ui:order"][0];
    const hasTab = uiSchema[firstComp]["ui:field"] === "tabfield";
    if (hasTab) {
        for (let tab in schema.properties) {
            for (let i = 0; i < uiSchema[tab]["ui:order"].length; i++) {
                const key = uiSchema[tab]["ui:order"][i];
                if (uiSchema[tab][key]["ui:field"] === "separator") {
                    parsedFormData[tab] = formData[tab];
                    parsedFormData[tab] = Object.assign(Object.assign({}, parsedFormData[tab]), formData[tab][key]);
                    for (let i = 0; i < uiSchema[tab][key]["ui:order"].length; i++) {
                        const subKey = uiSchema[tab][key]["ui:order"][i];
                        parsedFormData[subKey] = formData[tab][key][subKey];
                    }
                }
            }
            parsedFormData = Object.assign(Object.assign({}, parsedFormData), parsedFormData[tab]);
        }
    }
    else {
        for (let i = 0; i < uiSchema["ui:order"].length; i++) {
            const key = uiSchema["ui:order"][i];
            if (uiSchema[key]["ui:field"] === "separator") {
                parsedFormData[key] = formData[key];
                parsedFormData = Object.assign(Object.assign({}, parsedFormData), parsedFormData[key]);
            }
        }
    }
    let isArray = false;
    let parsedDataAsArray = [];
    if (JSON.stringify(formData).startsWith("[")) {
        isArray = true;
        Object.values(parsedFormData).forEach((value) => {
            parsedDataAsArray.push(value);
        });
    }
    return isArray ? parsedDataAsArray : parsedFormData;
}
export function flattenDataList(schema, uiSchema, formData) {
    let parsedFormData = _.cloneDeep(formData);
    if (parsedFormData === null ||
        typeof parsedFormData === "undefined" ||
        Object.keys(parsedFormData).length === 0) {
        return parsedFormData;
    }
    const firstComp = uiSchema["ui:order"][0];
    const hasTab = uiSchema[firstComp]["ui:field"] === "tabfield";
    for (let x = 0; x < formData.length; x++) {
        if (hasTab) {
            for (let tab in schema.properties) {
                for (let i = 0; i < uiSchema[tab]["ui:order"].length; i++) {
                    const key = uiSchema[tab]["ui:order"][i];
                    if (uiSchema[tab][key]["ui:field"] === "separator") {
                        parsedFormData[tab] = Object.assign(Object.assign({}, parsedFormData[tab]), formData[x][tab][key]);
                    }
                }
                parsedFormData = Object.assign(Object.assign({}, parsedFormData), parsedFormData[tab]);
            }
        }
        else {
            for (let i = 0; i < uiSchema["ui:order"].length; i++) {
                const key = uiSchema["ui:order"][i];
                if (uiSchema[key]["ui:field"] === "separator") {
                    parsedFormData = Object.assign(Object.assign({}, parsedFormData), parsedFormData[key]);
                }
            }
        }
    }
    return parsedFormData;
}
export const FocusFormDataContext = React.createContext({});
export const RowContext = React.createContext({
    value: {},
});
export const FocusFormLockStatusContext = React.createContext({
    lockStatus: false,
    handleLock: () => { },
    hasInitialValues: true,
    hidden: true,
});
//# sourceMappingURL=utils.js.map